import React, { FC, useMemo } from 'react';

import { IDocument } from '@sv-support-sdk/shared-types/src/common/documents'
import fileSizeFormat from '@sv-support-sdk/utils/src/helpers/fileSizeFormat';
import Actions from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions';
import ActionsItem from '@sv-support-sdk/ui-components/src/components/ControlLayout/Actions/ActionsItem';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import css from './style.module.scss';

import Button from '../../Controls/Button';

import { $l } from '../../../locales';
import useMobileDetect from '../../../hooks/useMobileDetect';

interface IProps {
  document: IDocument;
}

const Document: FC<IProps> = ({ document }) => {
  const isMobile = useMobileDetect();

  const fileSize = useMemo(() => fileSizeFormat(+document.size), [document.size]);

  return (
    <div className={css.document}>
      <div className={css.document__content}>
        <div className={css.document__icon}>
          <Icon
            id={document.extension === 'pdf' ? 'colored--32--doc-pdf' : 'colored--32--document'}
          />
        </div>
        <div className={css.document__details}>
          <div className={css.document__title}>{document.name}</div>
          <div className={css.document__info}>{fileSize}</div>
        </div>
      </div>
      <a href={document.url} download={document.name} className={css.document__actions}>
        <Actions>
          <ActionsItem width={isMobile ? "full" : "177"}>
            <Button
              variant={isMobile ? "transparent" : "primary-outlined"}
              icon="24--file-download-outlined"
              iconSize="24"
              text={isMobile ? "" : $l('HELP_CENTER_TOPIC.DOWNLOAD_GUIDE')}
            />
          </ActionsItem>
        </Actions>
      </a>
    </div>
  );
};

export default Document;
